import React from 'react';
import { Button, Typography, Layout, Result } from 'antd';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css'; // 引入CSS

const { Title } = Typography;
const { Content } = Layout;

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Layout className="not-found-layout">
      <Content className="not-found-content">
        <Result
          status="404"
          title={<Title level={1} className="not-found-title">404</Title>}
          subTitle="页面走丢啦~ 您访问的页面不存在"
          extra={
            <div className="not-found-btn-group">
              <Button
                size="large"
                icon={<ArrowLeftOutlined />}
                onClick={() => window.history.back()}
                className="not-found-btn"
              >
                返回上一页
              </Button>
              <Button
                type="primary"
                size="large"
                icon={<HomeOutlined />}
                onClick={() => navigate('/')}
                className="not-found-btn"
              >
                返回首页
              </Button>
            </div>
          }
          className="not-found-result"
        />
      </Content>
    </Layout>
  );
};

export default NotFound;